import { AnimationControls, useAnimationControls } from 'framer-motion';
import { useState, useEffect } from 'react';

const useCarousel = <T extends HTMLElement>(
	carousel_ref: HTMLElement | null,
	carousel_inner_ref: HTMLElement | null,
	dependency_array: Array<any>,
): [AnimationControls, { right: number; left: number }, 'x' | 'y' | boolean] => {
	// (왼쪽으로) 드래그할 수 있는 길이
	const [drag_constraints, setDragConstraints] = useState({ right: 0, left: 0 });
	const [drag_condition, setDragCondition] = useState<'x' | 'y' | boolean>(false);
	// 애니메이션을 작동시키기 위한 컨트롤
	const control = useAnimationControls();
	// 드래그 할 수 있는 조건
	const _drag_condition = () => {
		if (!carousel_inner_ref || !carousel_ref) return false;
		return carousel_inner_ref.scrollWidth - carousel_ref.offsetWidth <= 0 ? false : 'x';
	};

	useEffect(() => {
		if (carousel_inner_ref === null || carousel_ref === null) return;
		// 드래그 할 수 있는 길이 값 계산하여 반영 (DOM이 모두 렌더링 된 후에 반영하기 위해 setTimeout 적용)
		const width = carousel_inner_ref.scrollWidth - carousel_ref.offsetWidth;
		setDragConstraints({ right: 0, left: -width });
		// console.log('scrollable:', carousel_inner_ref.scrollWidth);
		// console.log('wrapper:', carousel_ref.offsetWidth);
		// console.log('width:', width);
		// transform의 translateX값 추출
		const transform = carousel_inner_ref?.style.transform;
		const transform_matched = transform?.match(/translateX*\(-?\d+.?\d{0,}px\)/) ?? '';
		const translateX = +transform_matched[0]?.split('translateX(')[1]?.split('px)')[0];

		setDragCondition(_drag_condition());

		// CloseChips에서 chips를 지웠을 때를 위한 애니메이션
		if (-translateX > carousel_inner_ref.scrollWidth - carousel_ref.offsetWidth) {
			control.start({
				x: -(carousel_inner_ref.scrollWidth - carousel_ref.offsetWidth),
			});
		}
	}, [carousel_ref, carousel_inner_ref, ...dependency_array]);
	// 애니메이션 컨트롤, 오른쪽으로 드래그 할 수 있는 길이, 드래그 할 수 있는 조건

	useEffect(() => {
		if (!carousel_inner_ref) return;

		const arr = carousel_inner_ref.children;

		for (let i = 0; i < arr.length; i++) {
			let x: number;
			arr[i].addEventListener('mousedown', (e: Event) => {
				const _e = e as MouseEvent;
				x = _e.clientX;
			});
			arr[i].addEventListener('click', (e: Event) => {
				const _e = e as MouseEvent;
				if (_e.clientX !== x) _e.stopImmediatePropagation();
			});
		}
	}, [carousel_inner_ref]);
	return [control, drag_constraints, drag_condition];
};

export default useCarousel;

// 캐로셀 구현 시 사용하는 훅
